module.exports = __webpack_public_path__ + "static/media/calendar-times.38f97464.svg";